import { svg } from 'lit';

const symbol = svg`<svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.368 1.368l13.264 13.264M1.368 14.632L14.632 1.368" stroke="#fff" stroke-linecap="square"/></svg>`;

export { symbol as default };
